export const getUrlParamByName = (name, query = window.location.search) => {
  if (!query || !name) {
    return;
  }

  query = query.replace(/^\?/, ``);
  const queryParts = query
    .split(`&`)
    .map((value) => {
      const data = value.split(`=`);

      if (data) {
        return {
          name: data[0],
          value: data[1]
        }
      }
    })
    .filter((value) => value !== null);

  const searchedPart = queryParts
    .filter((data) => data.name === name);

  if (searchedPart.length === 0) {
    return;
  }

  return decodeURIComponent(searchedPart[0].value);
};
